import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line

import AnimationRevealPage from "../helpers/AnimationRevealPage";
import MainFeature from "components/features/TwoColWithButton";
import Footer from "components/footers/FiveColumnWithBackground";
import Header from "../components/headers/light";
import TeamCardGrid from "../components/cards/ProfileThreeColGrid";

import contactUsSrc from "images/contact-us.png";

export default function ContactUs() {
  const Subheading = tw.span`uppercase tracking-widest font-bold text-primary-500`;
  const HighlightedText = tw.span`text-primary-500`;

  return (
    <AnimationRevealPage disabled>
      <Header />
      <MainFeature
        subheading={<Subheading>Contacto</Subheading>}
        heading={
          <>
            Con gusto estaremos respondiendo{" "}
            <span tw="text-primary-500">respondiendo tus mails.</span>
          </>
        }
        imageSrc={contactUsSrc}
        imageBorder={false}
        imageDecoratorBlob={true}
        withoutButton={true}
        showDescriptions={true}
        descriptions={[
          "Ante cualquier duda, sugerencia o soporte, podes enviarnos un mail a proy.ing.sw@gmail.com que con gusto estaremos respondiendo lo antes posible.",
          "Por cualquier otro asunto, podes encontrar los contactos de los integrantes del equipo más abajo.",
        ]}
      />
      {/* <TeamCardGrid
        subheading={<Subheading>Integrantes</Subheading>}
        heading={
          <>
            Nuestro equipo{" "}
            <HighlightedText>Interdisciplinario.</HighlightedText>
          </>
        }
        description={""}
      /> */}
      <Footer />
    </AnimationRevealPage>
  );
}
